import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
//Serivce
import ItemService from "../../../../services/supplier_appCommonService";
import toast from "react-hot-toast";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
// import { useNavigate } from "react-router-dom";

const PlantCreateModal = React.forwardRef((props, ref) => {
  // const navigate = useNavigate();
  const [formInputs, setFormInputs] = useState({
    plantCode:"",
    plantDescription:"",
    companyCode:"",
    companyName:"",
   
  });
  const [disabled, setDisabled] = useState();

  // Handle Submit IviteTeamMembers

  const handleSubmit = async () => {
    const payload = {
      data: {
        ...formInputs,
      },
    };
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    setDisabled(true);
    await ItemService.addCatalog(payload).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        toast.success(item?.message || "Material Added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onSuccess();
        props.onHide();
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };

  useEffect(() => {
    // console.log(">> props?.dropdownData", props?.dropdownData);
    // setDropdownOption(props?.dropdownData);

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };
  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {/* <i className="bi bi-plus-lg"></i>  */}
          Add Plant
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* accordin1 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-down" : "bi-chevron-right"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PI</span>
                </Col>
                <Col xs={8} md={9} lg={9}>
                  <span className="headerTitle">Plant Information</span>
                  <span className="subHeaderTitle">Plant Infromation</span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4 d-flex align-items-center">
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      //   label="Plant Code"
                      label={
                        <>
                          <i className="bi bi-upc-scan labelIcon"></i>
                          Plant Code
                        </>
                      }
                      id="plantCode"
                      name="plantCode"
                      type="text"
                      value={formInputs.plantCode || ""}
                      onChange={onInputChange}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <TextAreaField
                      placeholder=""
                      className="inputBox"
                      //   label="Plant Description"
                      label={
                        <>
                          <i className="bi bi-card-text labelIcon"></i>
                          Plant Description
                        </>
                      }
                      id="plantDescription"
                      name="plantDescription"
                      type="text"
                      value={formInputs.plantDescription || ""}
                      onChange={onInputChange}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      //   label="Company Code"
                      label={
                        <>
                          <i className="bi bi-hash labelIcon"></i>
                          Company Code
                        </>
                      }
                      id="companyCode"
                      name="companyCode"
                      type="text"
                      value={formInputs.companyCode || ""}
                      onChange={onInputChange}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      //   label="Company Name"
                      label={
                        <>
                          <i className="bi bi-building-fill labelIcon"></i>
                          Company Name
                        </>
                      }
                      id="companyName"
                      name="companyName"
                      type="text"
                      value={formInputs.companyName || ""}
                      onChange={onInputChange}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <form className="space-y-4">
          <Row className="justify-end">
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={() => props.onHide()}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleSubmit}
                disabled={disabled}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
              >
                Save
              </button>
            </Col>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              {/* <p className="errorMsg"> {errorMsg} </p> */}
            </Col>
          </Row>
        </form>
      </Modal.Body>
    </Modal>
  );
});

export default PlantCreateModal;
